module.exports = __webpack_public_path__ + "img/template_placeholder_green@2x.4f06179.png";